import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";

import { API_BASE } from "./constants";
import { AppService } from "services";
import { ApiResponse } from "entities";

const axiosHttp = axios.create();

/**
 * Can be used to set request token
 @param {AxiosRequestConfig} config The request options
 */
function requestInterceptor(config: InternalAxiosRequestConfig) {
  let cancelToken = config.data?.cancelToken;
  let headers = config.headers;

  if (cancelToken) {
    cancelToken.cancel();
  }

  const token = AppService.getAccessToken();

  if (token || token?.length) {
    headers.setAuthorization(token);
  }

  config.headers = headers;
  config.baseURL = API_BASE;
  config.responseType = "json";

  return config;
}

/**
 * Handle request error
 * @param {AxiosError} error
 */
function requestErrorInterceptor(error: AxiosError) {
  throw error;
}

/**
 * Handle response success
 * @param {AxiosResponse} response
 */
function responseSuccess(response: AxiosResponse) {
  return response;
}

/**
 * Handle response error
 * @param {AxiosError} error
 * @returns {Promise<{response: any}>}
 */
function responseError(error: AxiosError<ApiResponse<null>>) {
  throw error;
}

export const interceptorDefault = axiosHttp.interceptors.request.use(
  requestInterceptor,
  requestErrorInterceptor
);

axiosHttp.interceptors.response.use(responseSuccess, responseError);

export default axiosHttp;
